import { Component, Inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-user-response',
  standalone: true,
  imports: [],
  templateUrl: './user-response.component.html',
  styleUrl: './user-response.component.css'
})

export class UserResponseComponent extends HTMLElement implements OnInit {
  ngOnInit(): void {
  }

  @Input() adminMessage! : string
}
